import { IBaseDataParser } from "../../../core/src/server/parsers/IBaseDataParser";
import { IVendorData } from "../../model/IVendorData";
import { IRoundData } from "../../model/IVendorSpinData";
import { IRoundState, PlayResponse } from "../FTypes";

// TODO remove or add relevant data

export default class VendorDataParser implements IBaseDataParser<IVendorData> {
    check(data: PlayResponse<IRoundData, IRoundState>): boolean {
        let hasWager: boolean = false;
        !!data?.wager ? hasWager = true : !!data?.wagers ? hasWager = true : hasWager = false

        return hasWager;
    }

    parse(data: PlayResponse<IRoundData, IRoundState>): IVendorData {
        // console.log("Set next action to: ", (data.wager?.next?.[0] || data.wagers[0].next?.[0]));
        return {
            nextAction: data.wagers ? data.wagers[0]?.next?.[0] || "" : data.wager?.next?.[0] || "",
            playId: "",
            freeGames: data.wagers ? data.wagers : ""
        };
    }
}
